module.exports = __webpack_public_path__ + "media/SWV-I_Zahlen_sortieren_201113.828808f4.mp4";